(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["slicemaster-purchase-bottom"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('slice-master-purchase')) {
    customElements.define('slice-master-purchase', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form[is="product-form"]');
        this.addButton = this.querySelector('[name="add"]');
        this.buyNow = this.querySelector('[data-slicemaster-buy-now]');
        this.cartUrl = this.dataset.cartUrl;
        this.cartAddUrl = this.dataset.cartAddUrl;
        this.checkoutUrl = `${window.Shopify.routes.root}checkout`;
        this.buyNowError = this.dataset.buyNowError;
        this.errorMessage = this.querySelector('.slicemaster-form-error');
        this.productInfo = this.closest('product-info');
        this.currentVariant = this.readVariant('[data-selected-variant]');
        this.optimisticModeEnabled = this.isVariantSetEligible(this.readVariants());
        this.stabilizeVariantPicker();
        this.handleOptionChange = (event) => this.onOptionChange(event);
        this.handleNativeVariantChange = (event) => this.onNativeVariantChange(event.detail.variant);
        this.handleBuyNowClick = (event) => this.onBuyNowClick(event);

        this.form?.addEventListener('variant:change', this.handleNativeVariantChange);
        this.productInfo?.addEventListener('change', this.handleOptionChange);
        this.buyNow?.addEventListener('click', this.handleBuyNowClick);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('variant:change', this.handleNativeVariantChange);
        this.productInfo?.removeEventListener('change', this.handleOptionChange);
        this.buyNow?.removeEventListener('click', this.handleBuyNowClick);

        if (this.productInfo?.updateOptionValues === this.stableOptionRefresh) {
          this.productInfo.updateOptionValues = this.nativeOptionRefresh;
        }
      }

      get variantPicker() {
        return this.productInfo?.querySelector('variant-picker');
      }

      onOptionChange(event) {
        if (!event.target.closest('variant-picker')) return;

        const variant = this.findSelectedVariant();
        if (!this.canApplyOptimistically(variant)) {
          this.setBuyNowAvailability(false);
          return;
        }

        this.applyPurchaseVariant(variant);
      }

      onNativeVariantChange(variant) {
        const selectedVariant = this.findSelectedVariant();

        if (selectedVariant && String(selectedVariant.id) !== String(variant?.id)) {
          if (this.canApplyOptimistically(selectedVariant)) {
            this.applyPurchaseVariant(selectedVariant);
          }
          return;
        }

        if (variant) this.currentVariant = variant;
        this.syncVariant(variant);
      }

      async onBuyNowClick(event) {
        event.preventDefault();

        if (this.buyNowBusy || !this.currentVariant?.available) return;

        this.setBuyNowBusy(true);
        this.clearPurchaseError();

        try {
          const response = await fetch(this.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: this.currentVariant.id,
                quantity: 1
              }]
            })
          });
          const result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || this.buyNowError);
          }

          window.location.assign(this.checkoutUrl);
        } catch (error) {
          this.showPurchaseError(error.message || this.buyNowError);
          this.setBuyNowBusy(false);
        }
      }

      findSelectedVariant() {
        const picker = this.variantPicker;
        if (!picker) return null;
        if (picker.currentVariant) return picker.currentVariant;

        const selectedOptions = Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => {
          return fieldset.querySelector('input:checked')?.value;
        });

        if (selectedOptions.some((value) => !value)) return null;

        return this.readVariants().find((variant) => {
          if (variant.options.length !== selectedOptions.length) return false;
          return variant.options.every((option, index) => option === selectedOptions[index]);
        }) || null;
      }

      readVariants() {
        const variants = this.readVariant('[data-variants]');
        return Array.isArray(variants) ? variants : [];
      }

      readVariant(selector) {
        const data = this.variantPicker?.querySelector(selector)?.textContent;
        if (!data) return null;

        try {
          return JSON.parse(data);
        } catch {
          return null;
        }
      }

      isVariantSetEligible(variants) {
        if (!variants.length) return false;

        const reference = variants[0];
        return variants.every((variant) => {
          const valid = variant?.id
            && Array.isArray(variant.options)
            && typeof variant.available === 'boolean';
          const samePrice = Number(variant.price) === Number(reference.price)
            && Number(variant.compare_at_price || 0) === Number(reference.compare_at_price || 0);

          return Boolean(valid && samePrice);
        });
      }

      stabilizeVariantPicker() {
        if (!this.optimisticModeEnabled || typeof this.productInfo?.updateOptionValues !== 'function') return;

        this.nativeOptionRefresh = this.productInfo.updateOptionValues;
        this.stableOptionRefresh = () => {};
        this.productInfo.updateOptionValues = this.stableOptionRefresh;
      }

      canApplyOptimistically(variant) {
        if (!this.optimisticModeEnabled || !variant?.id || typeof variant.available !== 'boolean') return false;
        if (!this.currentVariant) return true;

        return Number(variant.price) === Number(this.currentVariant.price)
          && Number(variant.compare_at_price || 0) === Number(this.currentVariant.compare_at_price || 0);
      }

      applyPurchaseVariant(variant) {
        const variantInput = this.form?.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = String(variant.id);

        this.setAddButtonAvailability(variant.available);
        this.syncVariant(variant);
        this.updateUrl(variant.id);
        this.currentVariant = variant;
        this.dataset.optimisticVariantId = String(variant.id);
      }

      setAddButtonAvailability(available) {
        if (!this.addButton || this.addButton.hasAttribute('aria-busy')) return;

        if (typeof this.form?.toggleSubmitButton === 'function') {
          this.form.toggleSubmitButton(!available, theme.variantStrings.soldOut);
        } else {
          this.addButton.toggleAttribute('disabled', !available);
        }

        if (available) this.addButton.removeAttribute('aria-disabled');
      }

      updateUrl(variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }

      syncVariant(variant) {
        if (!this.buyNow) return;

        const available = Boolean(variant?.available);
        this.setBuyNowAvailability(available);
      }

      setBuyNowAvailability(available) {
        if (!this.buyNow) return;

        this.buyNow.classList.toggle('is-disabled', !available);
        this.buyNow.setAttribute('aria-disabled', String(!available));

        if (!this.buyNowBusy) {
          this.buyNow.toggleAttribute('disabled', !available);
        }
      }

      setBuyNowBusy(busy) {
        if (!this.buyNow) return;

        this.buyNowBusy = busy;
        this.buyNow.setAttribute('aria-busy', String(busy));
        this.buyNow.toggleAttribute('disabled', busy || !this.currentVariant?.available);
      }

      clearPurchaseError() {
        if (!this.errorMessage) return;

        this.errorMessage.hidden = true;
        this.errorMessage.textContent = '';
      }

      showPurchaseError(message) {
        if (!this.errorMessage) return;

        this.errorMessage.textContent = message;
        this.errorMessage.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
